// extracted by mini-css-extract-plugin
module.exports = {"dialogHidden":"Modal_dialogHidden_1v6cs"};